namespace('compass.demographic');

compass.require('compass.demographic.AddressWidget');

compass.demographic.PersonalInfoWidget = compass.defineWidget(function PersonalInfoWidget(options) {
	var me = this;
	var $j = jQuery;
	var iti;

	var _settings = options;
	var _addressWidgetJSObject = null;
	var _validator = options.validator;

	var _labels = {
		first_name: {
			label: 'First Name',
			hint: 'A valid first name is required. First name must be 20 or less characters'
		},
		last_name: {
			label:  'Last Name',
			hint: 'A valid last name is required. Last name must be 20 or less characters'
		},
		title: {
			label: 'title',
			hint: ''
		},
		salutation: {
			label: 'salutation',
			hint: ''
		},
		phone: {
			label: 'Phone Number',
			hint: 'Phone number must be at least 7 digits, and include only digits and dashes'
		},
		email: {
			label: 'Email Address',
			hint: 'A valid email address is required'
		},
		company_name: {
			label: "Company Name",
			hint: 'A valid company name is required'
		}
	};

	var _grabValues = this.grabValues = function() {
		if (_settings.prefill) {
			return { };
		}

		var values = me.find(':input,:selected').serializeArray();
		var jsonValues = {};
		jQuery.each(values, function(i, field) {
			jsonValues[field.name] = field.value;
		});

		if(_settings.drawInternationalPhone) {
			var intPhoneNumber = iti.getNumber(intlTelInputUtils.numberFormat.INTERNATIONAL);
			if(intPhoneNumber.length > 0) {
				jsonValues['phone'] = intPhoneNumber;
			}
		}

		if (_settings.drawAddress) {
			jsonValues.address = _addressWidgetJSObject.getAddress();
		}

		return jsonValues;
	};

	var _dupeFields = [];
	var _dupeCheck = function (event) {
		var rdy = _.reduce(_dupeFields, function(stat, c) {
			if (c.val().length > 0 && !c.hasClass('invalid')) {
				return stat && true;
			} else {
				return false;
			}
		}, true);

		if (rdy) {
			var props = {};
			_.each(_dupeFields, function(c) {
				props[c.attr("name")] = c.val();
			});
			me.trigger('PersonalInfoWidget.DupeCheckReady', props);
		}
	};

	var _validatePhoneNumber = this.validatePhoneNumber = function() {
		return iti.isValidNumber();
	};

	this.getAddressWidgetJSObject = function() {
		return _addressWidgetJSObject;
	};

	this.showErrorDiv = function() {
		// do nothing since we are doing inline errors.
	};

	this.hideErrorDiv = function() {
		// do nothing since we are doing inline errors.
	};

	var _setupControls = function() {
		var me = this;

		if(_settings.drawInternationalPhone) {
			phoneInput = $j.find('.phoneInput.phone')[0];
			iti = window.intlTelInput(phoneInput, { 
				separateDialCode: true,
				allowDropdown: true,
				initialCountry: 'US',
				preferredCountries: ['us'],
				utilsScript: compass.staticPrefix + "/resources/js/core/intlTelInput-utils.js"
			});
		}
	};
	var _render = this.render = function(widgetElem) {

		var prefillCompanyName = function() {
			return _settings.drawCompanyName && _settings.prefill.companyName ? d.div({className: 'companyName'}, _settings.prefill.companyName) : '';
		};

		var d = _d;
		// settings.prefill will prevent the new reg integration editablePrefill
		if (_settings.prefill) {
			widgetElem.append(
				d.div({
					className: 'prefill'
				}, d.span({
						className: 'indivName'
					}, _settings.prefill.firstName + ' ' + _settings.prefill.lastName),
					prefillCompanyName(),
					d.div({
						className: 'email'
					}, _settings.prefill.email),
					d.div({
						className: 'phone'
					}, _settings.prefill.phone)
				)
			);
			return;
		}

		_addressHolder = d.div({
			className : "personalInfoWidgetAddressWidget subwidgetdiv personalInfoWidgetAddressDiv"
		});

		if(_settings.drawAddress) {
			_addressWidgetJSObject = new compass.demographic.AddressWidget(_addressHolder, {
				WUID : _settings.WUID,
				validator: _validator
			});
		}

		if(_settings.drawSalutation) {
			widgetElem.append(me.drawSalutation());
		}

		widgetElem.append(
			this.drawFirstName(),
			this.drawLastName(),
			_settings.drawCompanyName ? this.drawCompanyName(_.contains(_settings.extraRequiredFields, 'companyName')) : ''
		);

		if(_settings.drawTitle) {
		 	widgetElem.append(me.drawTitle());
		}

		if(_settings.drawAddress) {
			widgetElem.append(_addressHolder);
		}

		widgetElem.append(
			me.drawEmail(),
			me.drawPhone()
		);

		me.find("#email-input").emailautocomplete({
			suggClass: "eac-sugg",
			domains: ["aol.com", "att.net", "bellsouth.net", "comcast.com", "comcast.net", "gmail.com", "hotmail.com", "icloud.com", "live.com", "me.com", "msn.com", "outlook.com", "qq.com", "sbcglobal.net", "yahoo.com", "ymail.com"]
		});

		_setupControls();
	};

	this.drawFirstName = function() {
		var d = _d;
		var input = d.input({
			type : 'text',
			name : "firstName",
			value: _settings.editablePrefill ? _settings.editablePrefill.firstName : '',
			className : "firstName firstNameInput",
			autocomplete: 'off',
			'tabindex': '0',
			id: compass.generateId(),
			'data-parsley-error-message': _labels.first_name.hint,
			'data-parsley-required': 'true',
			'data-parsley-pattern': /[^\d\s\.\/\-]/,  //Contains at least 1 letter
			'data-parsley-maxlength': '20'
		}).data("hint", _labels.first_name.hint)
		.blur(_dupeCheck);
		_dupeFields.push(input);
		var field = d.fieldLabelPair({
			className : 'firstName',
			label : _labels.first_name.label
		}, [input]);
		if (_validator) {
			_validator.addFields(field.find('input'), _validator.NAME, { });
		}
		return field;
	};

	this.drawLastName = function() {
		var d = _d;
		var input = d.input({
			type : 'text',
			name : 'lastName',
			value: _settings.editablePrefill ? _settings.editablePrefill.lastName : '',
			className : 'lastName lastNameInput',
			autocomplete: 'off',
			'tabindex': '0',
			id: compass.generateId(),
			'data-parsley-error-message': _labels.last_name.hint,
			'data-parsley-required': 'true',
			'data-parsley-pattern': /[^\d\s\.\/\-]/,  //Contains at least 1 letter
			'data-parsley-maxlength': '20'
		}).data("hint", _labels.last_name.hint)
			.blur(_dupeCheck);
		_dupeFields.push(input);
		var field = d.fieldLabelPair({
			className : 'lastName',
			label : _labels.last_name.label
		}, [input]);
		if (_validator) {
			_validator.addFields(field.find('input'), _validator.NAME, { });
		}
		return field;
	};

	this.drawCompanyName = function(required) {
		var d = _d;
		var input = d.input({
			type : 'text',
			name : 'companyName',
			value: _settings.editablePrefill ? _settings.editablePrefill.companyName : '',
			className : 'companyName companyNameInput',
			autocomplete: 'off',
			'tabindex': '0',
			id: compass.generateId()
		}).data("hint", _labels.company_name.hint);
		var field = d.fieldLabelPair({
			className : 'companyName',
			label : _labels.company_name.label
		}, [input]);
		input.attr({
			'data-parsley-error-message': _labels.company_name.hint,
			'data-parsley-required': 'false',
			'data-parsley-pattern': /[^\d\s\.\/\-]/  //Contains at least 1 letter
		});
		if (required) {
			input.attr({'data-parsley-required': 'true'});
			if (_validator) {
				_validator.addFields(field.find('input'), _validator.NAME, { });
			}
		}
		return field;
	};

	this.drawTitle = function() {
		var d = _d;
		var field = d.fieldLabelPair({
			className : 'title',
			label : _labels.title.label
		}, [d.input({
			type : 'text',
			name : 'title',
			className : 'title titleInput',
			'tabindex': '0',
			autocomplete: 'off'
		}).data("hint", _labels.title.hint)]);
		return field;
	};

	this.drawSalutation = function() {
		var d = _d;
		var field = d.fieldLabelPair({
			className : 'salutation',
			label : _labels.salutation.label
		}, [d.input({
			type : 'text',
			name : 'salutation',
			className : 'salutation salutationInput',
			'tabindex': '0',
			autocomplete: 'off'
		}).data("hint", _labels.salutation.hint)]);
		return field;
	};

	this.drawPhone = function() {
		var d = _d;
		var _phoneId = compass.generateId();
		var _alertId = compass.generateId();
		var infoButton = d.div({},
			_labels.phone.label,
			d.span({
				className : 'receiptInfoImg',
				role : 'button',
				'ARIA-role' : 'button',
				'ARIA-labelledby' : _phoneId,
				'ARIA-owns' : _alertId,
				tabindex : 0
			}).activate(function() {
				compass.GA.trackEvent('Additional Information', 'Phone Number', 'Expedia Individual Info');
				d.alert({
					id: _alertId,
					message: 'We will only contact you if there is an issue with your reservation.',
					includeImage: false
				});
			})
		);
		var input = d.input({
			type : 'tel',
			value: _settings.editablePrefill ? _settings.editablePrefill.phone : '',
			className : 'phoneInput phone',
			name : 'phone',
			pattern : "^\\+?([\\s\\.\\-\\(\\)]*\\d){7,}$",
			autocomplete: 'off',
			'tabindex': '0',
			id: compass.generateId(),
			'data-parsley-required': 'true',
			'data-parsley-error-message': _labels.phone.hint,
			'data-parsley-regexp': "^\\+?([\\s\\.\\-\\(\\)]*\\d){7,}$"
		}).data("hint", _labels.phone.hint);
		var field = d.fieldLabelPair({
			className : 'phone',
			label : _settings.affiliate === 'EAN' ? infoButton : _labels.phone.label
		}, [input]);
		if (_validator) {
			_validator.addFields(field.find('input'), _validator.PHONE, { });
		}
		return field;
	};

	this.drawEmail = function() {
		var d = _d;
		var input = d.input({
			className : 'emailInput email email-autocomplete',
			name : 'email',
			type : 'email',
			value:_settings.editablePrefill ? _settings.editablePrefill.email: '',
			autocomplete: 'off',
			'tabindex': '0',
			id: 'email-input',
			'data-parsley-required': 'true',
			'data-parsley-error-message': _labels.email.hint,
			'data-parsley-type': 'email'
		}).data("hint", _labels.email.hint)
		.blur(_dupeCheck);
		_dupeFields.push(input);
		var field = d.fieldLabelPair({
			className : 'email',
			label : _labels.email.label
		}, [input]);
		if (_validator) {
			_validator.addFields(field.find('input'), _validator.EMAIL, { });
		}
		return field;
    };

	this.drawEndingDiv = function() {
		var d = _d;
		return d.div({className : 'endPersonalWidget'});
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'PersonalInfoWidget',
	imgPath : '/resources/img',
	subclass : false,
	drawSalutation : false,
	drawAddress : false,
	drawTitle : false,
	drawCompanyName : false,
	prefill: null,
	extraRequiredFields: null,
	drawInternationalPhone: false
});
